import React from "react";
import { CITY_ID, CONTENT_TYPE } from "../../constants/fiasAPI";

import Asynchronous from "./Asynchronous/Asynchronous";
import { AsynchronousProps } from "../../types/common";

interface Props extends Omit<AsynchronousProps, "onChange"> {
    cityId: string;
    onChange: (value: string) => void;
}

const StreetSelect = ({ onChange, value, field, error, callbackResult, cityId, disabled }: Props) => {
    return (
        <Asynchronous
            onChange={item => {
                onChange(item?.data?.street_with_type ?? "");
            }}
            getParam="street_with_type"
            locations={[{ fias_id: cityId }]}
            value={value}
            label={"Улица"}
            error={error}
            callbackResult={callbackResult}
            from_bound={{ value: "street" }}
            to_bound={{ value: "street" }}
            disabled={disabled}
            // searchParams={{ [CONTENT_TYPE]: "street", [CITY_ID]: cityId }}
        />
    );
};

export default StreetSelect;
